import React  from 'react';
import { EditGuesser, InputGuesser } from "@api-platform/admin";
import { ReferenceArrayInput, AutocompleteInput, AutocompleteArrayInput, BooleanInput, ReferenceInput, SelectInput } from 'react-admin';
import { RichTextInput } from '@agilie/ra-tinymce-input';
import CreateInAutocomplete from '../Tag/CreateInAutocomplete';

const BlogEdit = (props) => (
  <EditGuesser {...props}>
    <InputGuesser source="name" />
    <InputGuesser source="title" />
    <InputGuesser source="metaTitle" />
    <p>Content:</p>
    <RichTextInput label="Content" source="content"
      apiKey='kajmvp4egjobgynq3phsfqif168so5skv2apq56c5zmjum5a'
      init={{
          height: 500,
          menubar: true,
          plugins: [
              'advlist autolink lists link image charmap print preview anchor',
              'searchreplace visualblocks code fullscreen',
              'insertdatetime media table paste code help wordcount'
          ],
          toolbar: 'undo redo | formatselect | ' +
              'bold italic backcolor | alignleft aligncenter ' +
              'alignright alignjustify | bullist numlist outdent indent | ' +
              'removeformat | help',
          content_style: 'body { font-family:Helvetica,Arial,sans-serif; font-size:14px }'
      }}
    />
    <p>Hero text:</p>
    <RichTextInput label="Hero text" source="heroText"
      apiKey='kajmvp4egjobgynq3phsfqif168so5skv2apq56c5zmjum5a'
      init={{
          height: 500,
          menubar: true,
          plugins: [
              'advlist autolink lists link image charmap print preview anchor',
              'searchreplace visualblocks code fullscreen',
              'insertdatetime media table paste code help wordcount'
          ],
          toolbar: 'undo redo | formatselect | ' +
              'bold italic backcolor | alignleft aligncenter ' +
              'alignright alignjustify | bullist numlist outdent indent | ' +
              'removeformat | help',
          content_style: 'body { font-family:Helvetica,Arial,sans-serif; font-size:14px }'
      }}
    />
    <p>Meta Description:</p>
    <RichTextInput label="Meta Description" source="metaDescription"
      apiKey='kajmvp4egjobgynq3phsfqif168so5skv2apq56c5zmjum5a'
      init={{
          height: 500,
          menubar: true,
          plugins: [
              'advlist autolink lists link image charmap print preview anchor',
              'searchreplace visualblocks code fullscreen',
              'insertdatetime media table paste code help wordcount'
          ],
          toolbar: 'undo redo | formatselect | ' +
              'bold italic backcolor | alignleft aligncenter ' +
              'alignright alignjustify | bullist numlist outdent indent | ' +
              'removeformat | help',
          content_style: 'body { font-family:Helvetica,Arial,sans-serif; font-size:14px }'
      }}
    />
    <ReferenceInput
      label="File"
      source="file"
      reference="files"
      perPage={200}
      filter={{ title: "Blog" }}
    >
      <AutocompleteInput
        optionText="title"
        shouldRenderSuggestions={(value) => value.trim().length >= 3}
      />
    </ReferenceInput>
    <ReferenceInput label="Language" source="language" reference="languages">
      <SelectInput optionText="name" />
    </ReferenceInput>
    <ReferenceInput label="Category" source="category" reference="blog_categories">
      <SelectInput optionText="title" />
    </ReferenceInput>
    <ReferenceArrayInput source="tags" reference="tags">
        <AutocompleteArrayInput create={<CreateInAutocomplete />} />
    </ReferenceArrayInput>
    <BooleanInput source="enabled" defaultValue={true} />
  </EditGuesser>
  );

export default BlogEdit;